var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pivot-field-selector" }, [
    _c(
      "div",
      { staticClass: "selector-header" },
      [
        _c("span", { staticClass: "selector-title" }, [
          _vm._v(_vm._s(_vm.displayTitle)),
        ]),
        _vm._v(" "),
        _vm.allowMultiple && _vm.selectedFields.length > 0
          ? _c(
              "a-button",
              {
                attrs: { type: "link", size: "small" },
                on: { click: _vm.clearAll },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("table.clearAll")) +
                    "\n        "
                ),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "field-filter" },
      [
        _c("a-input-search", {
          attrs: {
            placeholder: _vm.$t("table.searchField"),
            size: "small",
            allowClear: "",
          },
          model: {
            value: _vm.searchQuery,
            callback: function ($$v) {
              _vm.searchQuery = $$v
            },
            expression: "searchQuery",
          },
        }),
        _vm._v(" "),
        _c(
          "a-select",
          {
            staticStyle: { width: "150px", "margin-left": "8px" },
            attrs: {
              size: "small",
              placeholder: _vm.$t("table.filterType"),
              allowClear: "",
            },
            model: {
              value: _vm.typeFilter,
              callback: function ($$v) {
                _vm.typeFilter = $$v
              },
              expression: "typeFilter",
            },
          },
          [
            _c("a-select-option", { attrs: { value: "all" } }, [
              _vm._v(_vm._s(_vm.$t("table.all"))),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "number" } }, [
              _vm._v(_vm._s(_vm.$t("table.numeric"))),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "string" } }, [
              _vm._v(_vm._s(_vm.$t("table.text"))),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "date" } }, [
              _vm._v(_vm._s(_vm.$t("table.date"))),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _vm.allowMultiple && _vm.selectedFields.length > 0
      ? _c(
          "div",
          { staticClass: "selected-fields" },
          [
            _c("div", { staticClass: "selected-title" }, [
              _vm._v(
                _vm._s(_vm.$t("table.selectedFields")) +
                  " (" +
                  _vm._s(_vm.selectedFields.length) +
                  ")"
              ),
            ]),
            _vm._v(" "),
            _c(
              "draggable",
              {
                attrs: { options: { animation: 200, handle: ".drag-handle" } },
                on: { end: _vm.onOrderChanged },
                model: {
                  value: _vm.selectedFieldsModel,
                  callback: function ($$v) {
                    _vm.selectedFieldsModel = $$v
                  },
                  expression: "selectedFieldsModel",
                },
              },
              _vm._l(_vm.selectedFieldsModel, function (fieldId, index) {
                return _c(
                  "div",
                  { key: fieldId, staticClass: "selected-field-item" },
                  [
                    _c("i", { staticClass: "material-icons drag-handle" }, [
                      _vm._v("drag_indicator"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "field-name" }, [
                      _vm._v(_vm._s(_vm.getFieldName(fieldId))),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "field-type" }, [
                      _vm._v(_vm._s(_vm.getFieldType(fieldId))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "i",
                      {
                        staticClass: "material-icons remove-icon",
                        on: {
                          click: function ($event) {
                            return _vm.removeField(fieldId)
                          },
                        },
                      },
                      [_vm._v("\n                    close\n                ")]
                    ),
                  ]
                )
              }),
              0
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "available-fields" }, [
      _c("div", { staticClass: "available-title" }, [
        _vm._v(_vm._s(_vm.$t("table.availableFields"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "field-list" },
        _vm._l(_vm.filteredFields, function (field) {
          return _c(
            "div",
            {
              key: field._id,
              staticClass: "field-item",
              class: { "is-selected": _vm.isFieldSelected(field._id) },
              on: {
                click: function ($event) {
                  return _vm.toggleField(field._id)
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons field-icon" }, [
                _vm._v(_vm._s(_vm.getFieldIcon(field))),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "field-name" }, [
                _vm._v(_vm._s(field.name)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "field-type-badge" }, [
                _vm._v(_vm._s(_vm.getFieldTypeLabel(field))),
              ]),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }